export const templateDataCourse = [
  {
    name: 'Default',
    id: 0,
    path: 'sections',
    font: 'Inter',
    primaryColor: '#015FFB',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/Default.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/Default.png',
        },
      },
      {
        type: 'Main',
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
              <p id="introduction-description">Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
              </div>
            </div>
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%);" id="author-title">Meet Your Instructor</span></h2>
              <p id="author-description">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="button-wrapper" data-alignment="center" data-sizing="fit">
                <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="X" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:new-twitter" iconname="hugeicons:new-twitter" width="18" height="18">&nbsp;</iconify-icon>X
                </a>
                <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Facebook" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:facebook-01" iconname="hugeicons:facebook-01" width="18" height="18">&nbsp;</iconify-icon>Facebook
                </a>
                <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Instagram" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:instagram" iconname="hugeicons:instagram" width="18" height="18">&nbsp;</iconify-icon>Instagram
                </a>
                <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Tiktok" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:tiktok" iconname="hugeicons:tiktok" width="18" height="18">&nbsp;</iconify-icon>Tiktok
                </a>
                <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Linkedin" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:linkedin-01" iconname="hugeicons:linkedin-01" width="18" height="18">&nbsp;</iconify-icon>Linkedin
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%);" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(217,99%,49%);" id="program_details-title">Program Details</span></h2>
              <p style="text-align:center;" id="program_details-description">Includes access to premium content, community discussions, and expert feedback.</p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="card-wrapper">
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="level">Beginner level</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="duration">3 weeks</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="recommended_interval">4-10 hours per week</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="price">$10,00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%);" id="audience-title">Who Is This For?</span></h2>
              <p id="audience-description">This program is designed for individuals who want to:</p>
              <div class="column-header">
                <ul id="audience-items">
                  <li>Develop valuable skills for personal or professional growth </li>
                  <li>Apply knowledge through interactive activities</li>
                </ul>
              </div>
              <div class="column-header">
                <ul>
                  <li>Improve efficiency and confidence in their abilities </li>
                  <li>Take meaningful steps toward their goals</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%);" id="learning_outcomes-title">What You'll Learn</span></h2>
              <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including: </strong></p>
              <ul id="learning_outcomes-items">
                <li>Essential concepts explained in a clear and engaging way</li>
                <li>Real-world applications to deepen understanding </li>
                <li>Step-by-step guidance to build confidence </li>
                <li>Interactive exercises to reinforce learning </li>
                <li>Access to exclusive resources and tools</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(217,99%,49%);" id="outro-title">Ready to Get Started?</span></h2>
              <p id="outro-description" style="text-align:center;">Explore the content, dive into new ideas, and expand your knowledge at your own pace.</p>
            </div>
          </div>
        </div>`,
        },
      },
    ],
  },
  {
    name: 'Classic',
    id: 1,
    path: 'sections',
    font: 'Questrial',
    primaryColor: '#001B47',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/classic.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/classic.png',
        },
      },
      {
        type: 'Main',
        content: {
          html: `  <div class="simple-box-wrapper" style="background-color:'';">
        <div class="simple-box">
            <div class="column">
                <h2><span style="color:hsl(217, 100%, 14%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
                <p id="introduction-description">Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</p>
            </div>
        </div>
    </div>
    
    
    
    <!-- Meet Your Instructor Section -->
    <div class="simple-box-wrapper" style="background-color:#001b47;">
        <div class="simple-box">
            <div class="column">
                <div class="img-wrapper">
                    <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
                </div>
            </div>
            <div class="column">
                <h2><span style="color:hsl(0, 0%, 100%);" id="author-title">Meet Your Instructor</span></h2>
                <p id="author-description"><span style="color:hsl(0, 0%, 100%);">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</span></p>
            </div>
        </div>
    </div>
    
    
    
    <!-- Social Media Buttons Section -->
    <div class="simple-box-wrapper" style="background-color:#001b47;" background-color="#001b47">
        <div class="simple-box">
            <div class="column">
                <div class="button-wrapper" data-alignment="center" data-sizing="fit">
                    <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" target="_blank">
                        <iconify-icon class="simple-icon" icon="hugeicons:new-twitter" width="18" height="18">&nbsp;</iconify-icon>X
                    </a>
                    <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" target="_blank">
                        <iconify-icon class="simple-icon" icon="hugeicons:facebook-01" width="18" height="18">&nbsp;</iconify-icon>Facebook
                    </a>
                    <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" target="_blank">
                        <iconify-icon class="simple-icon" icon="hugeicons:instagram" width="18" height="18">&nbsp;</iconify-icon>Instagram
                    </a>
                    <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" target="_blank">
                        <iconify-icon class="simple-icon" icon="hugeicons:tiktok" width="18" height="18">&nbsp;</iconify-icon>Tiktok
                    </a>
                    <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" target="_blank">
                        <iconify-icon class="simple-icon" icon="hugeicons:linkedin-01" width="18" height="18">&nbsp;</iconify-icon>Linkedin
                    </a>
                </div>
            </div>
        </div>
    </div>
    
    
    
    <!-- Earn Your Credential Section -->
    <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:#001B47" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
              </div>
            </div>
          </div>
        </div>
    
    
    
    <!-- Program Details Section -->
    <div class="simple-box-wrapper" style="background-color:#001b47;" background-color="#001b47">
        <div class="simple-box">
            <div class="column">
                <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 100%);" id="program_details-title">Program Details</span></h2>
                <p style="text-align:center;" id="program_details-description"><span style="color:hsl(0, 0%, 100%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
            </div>
        </div>
    </div>
    
    
    
    <!-- Program Stats Section -->
    <div class="simple-box-wrapper" style="background-color:#001b47;" background-color="#001b47">
        <div class="simple-box">
            <div class="column">
                <div class="card-wrapper">
                    <div class="card-box" type="highlightCard">
                        <div class="card-header">
                            <button class="card-icon-button">
                                <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                            </button>
                        </div>
                        <div class="card-content">
                            <p id="level">Beginner level</p>
                        </div>
                    </div>
                    <div class="card-box" type="highlightCard">
                        <div class="card-header">
                            <button class="card-icon-button">
                                <iconify-icon class="simple-icon" icon="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                            </button>
                        </div>
                        <div class="card-content">
                            <p id="duration">3 weeks</p>
                        </div>
                    </div>
                    <div class="card-box" type="highlightCard">
                        <div class="card-header">
                            <button class="card-icon-button">
                                <iconify-icon class="simple-icon" icon="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                            </button>
                        </div>
                        <div class="card-content">
                            <p id="recommended_interval">4-10 hours per week</p>
                        </div>
                    </div>
                    <div class="card-box" type="highlightCard">
                        <div class="card-header">
                            <button class="card-icon-button">
                                <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                            </button>
                        </div>
                        <div class="card-content">
                            <p id="price">$10,00</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    
    
    <!-- Who Is This For Section -->
    <div class="simple-box-wrapper">
        <div class="simple-box">
            <div class="column">
                <h2><span id="audience-title">Who Is This For?</span></h2>
                <p id="audience-description"><span>This program is designed for individuals who want to:</span></p>
            </div>
        </div>
    </div>
    
    
    
    <!-- Individual Categories Section -->
    <div class="simple-box-wrapper">
        <div class="simple-box">
            <div class="column">
                <div class="card-wrapper" id="audience-items">
                    <div class="card-box" type="numberedCard">
                        <div class="card-header">
                            <p>01</p>
                        </div>
                        <div class="card-content">
                            <p><span>Develop valuable skills for personal or professional growth</span></p>
                        </div>
                    </div>
                    <div class="card-box" type="numberedCard">
                        <div class="card-header">
                            <p>02</p>
                        </div>
                        <div class="card-content">
                            <p><span>Apply knowledge through interactive activities</span></p>
                        </div>
                    </div>
                    <div class="card-box" type="numberedCard">
                        <div class="card-header">
                            <p>03</p>
                        </div>
                        <div class="card-content">
                            <p><span>Improve efficiency and confidence in their abilities</span></p>
                        </div>
                    </div>
                    <div class="card-box" type="numberedCard">
                        <div class="card-header">
                            <p>04</p>
                        </div>
                        <div class="card-content">
                            <p><span>Take meaningful steps toward their goals</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!-- What You'll Learn Section -->
    <div class="simple-box-wrapper">
        <div class="simple-box">
            <div class="column">
                <h2><span style="color:hsl(217, 100%, 14%);" id="learning_outcomes-title">What You'll Learn</span></h2>
                <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including: </strong></p>
                <ul id="learning_outcomes-items">
                    <li>Essential concepts explained in a clear and engaging way</li>
                    <li>Real-world applications to deepen understanding </li>
                    <li>Step-by-step guidance to build confidence </li>
                    <li>Interactive exercises to reinforce learning </li>
                    <li>Access to exclusive resources and tools</li>
                </ul>
            </div>
        </div>
    </div>
    
    
    
    <!-- Call to Action Section -->
    <div class="simple-box-wrapper" style="background-color:#001b47;" background-color="#001b47">
        <div class="simple-box">
            <div class="column">
                <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 100%);" id="outro-title">Ready to Get Started?</span></h2>
                <p style="text-align:center;" id="outro-description"><span style="color:hsl(0, 0%, 100%);">Explore the content, dive into new ideas, and expand your knowledge at your own pace.</span></p>
            </div>
        </div>
    </div>`,
        },
      },
    ],
  },
  {
    name: 'Minimal',
    id: 2,
    path: 'sections',
    font: 'Lato',
    primaryColor: '#7346F1',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/minimal.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'left',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/minimal.png',
        },
      },
      {
        type: 'Main',
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(256, 86%, 61%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
              <p id="introduction-description"><span>Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
            </div>
          </div>
        </div>

        

        <div class="simple-box-wrapper" style="background-color:#f5f7fe;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#f5f7fe" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(256, 86%, 61%);" id="program_details-title">Program Details</span></h2>
              <p style="text-align:center;" id="program_details-description">Includes access to premium content, community discussions, and expert feedback.</p>
            </div>
          </div>
        </div>

        

        <div class="simple-box-wrapper" style="background-color:#f5f7fe;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#f5f7fe" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="card-wrapper" id="program_details-cards">
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="level">Beginner level</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="duration">3 weeks</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="recommended_interval">4-10 hours per week</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="price">$10,00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
              </div>
            </div>
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(256, 86%, 61%);" id="author-title">Meet Your Instructor</span></h2>
              <p id="author-description">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</p>
            </div>
          </div>
        </div>

        

        <div class="simple-box-wrapper" style="background-color:#ffffff;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#ffffff" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="button-wrapper" data-alignment="left" data-sizing="fit" id="social-links">
                <a class="simple-button" style="border:1px solid #7346f1;color:#7346f1;" href="" text="X" textcolor="#7346f1" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:new-twitter" iconname="hugeicons:new-twitter" width="18" height="18">&nbsp;</iconify-icon>X
                </a>
                <a class="simple-button" style="border:1px solid #7346f1;color:#7346f1;" href="" text="Facebook" textcolor="#7346f1" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:facebook-01" iconname="hugeicons:facebook-01" width="18" height="18">&nbsp;</iconify-icon>Facebook
                </a>
                <a class="simple-button" style="border:1px solid #7346f1;color:#7346f1;" href="" text="Instagram" textcolor="#7346f1" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:instagram" iconname="hugeicons:instagram" width="18" height="18">&nbsp;</iconify-icon>Instagram
                </a>
                <a class="simple-button" style="border:1px solid #7346f1;color:#7346f1;" href="" text="Tiktok" textcolor="#7346f1" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:tiktok" iconname="hugeicons:tiktok" width="18" height="18">&nbsp;</iconify-icon>Tiktok
                </a>
                <a class="simple-button" style="border:1px solid #7346f1;color:#7346f1;" href="" text="Linkedin" textcolor="#7346f1" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:linkedin-01" iconname="hugeicons:linkedin-01" width="18" height="18">&nbsp;</iconify-icon>Linkedin
                </a>
              </div>
            </div>
          </div>
        </div>

        

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(256, 86%, 61%);" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
              </div>
            </div>
          </div>
        </div>

        

        <div class="simple-box-wrapper" style="background-color:#7346f1;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#7346f1" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <blockquote id="instructor-quote">
              <h2><span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span><span style="color:hsl(0, 0%, 100%);">"Learning is a journey, not a destination. Stay curious, explore new ideas, and grow at your own pace."Gain insights from an experienced mentor who will guide you through key concepts and real-world applications."</span></h2>
              <p><span style="color:hsl(0, 0%, 100%);"><i>– </i><span>Instructor</span></span></p>
            </blockquote>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(256, 86%, 61%);" id="audience-title">Who Is This For?</span></h2>
              <p id="audience-description">This program is designed for individuals who want to:</p>
              <div class="column-header">
                <ul id="audience-items">
                  <li>Develop valuable skills for personal or professional growth</li>
                  <li>Apply knowledge through interactive activities</li>
                </ul>
              </div>
              <div class="column-header">
                <ul>
                  <li>Improve efficiency and confidence in their abilities</li>
                  <li>Take meaningful steps toward their goals</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217, 100%, 14%);" id="learning_outcomes-title">What You'll Learn</span></h2>
              <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including:</strong></p>
              <ul id="learning_outcomes-items">
                <li>Essential concepts explained in a clear and engaging way</li>
                <li>Real-world applications to deepen understanding</li>
                <li>Step-by-step guidance to build confidence</li>
                <li>Interactive exercises to reinforce learning</li>
                <li>Access to exclusive resources and tools</li>
              </ul>
            </div>
          </div>
        </div>

        

        <div class="simple-box-wrapper" style="background-color:#7346f1;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#7346f1" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 100%);" id="outro-title">Ready to Get Started?</span></h2>
              <p style="text-align:center;" id="outro-description"><span style="color:hsl(0, 0%, 100%);">Explore the content, dive into new ideas, and expand your knowledge at your own pace.</span></p>
            </div>
          </div>
        </div>`,
        },
      },
    ],
  },
  {
    name: 'Elegant',
    id: 3,
    path: 'sections',
    font: 'Barlow',
    primaryColor: '#947100 ',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/elegant.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/elegant.png',
        },
      },
      {
        type: 'Main',
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(46, 100%, 29%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span>Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
            </div>
          </div>
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(46, 100%, 29%);" id="author-title">Meet Your Instructor</span></h2>
            <p id="author-description">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#f5f5f5;background-image:'';background-position:'';background-size:'';" background-image="" background-color="#f5f5f5" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="button-wrapper" data-alignment="center" data-sizing="fit" id="social-links">
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Shopify" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:shopify" iconname="hugeicons:shopify" width="18" height="18">&nbsp;</iconify-icon>Shopify
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Instagram" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:instagram" iconname="hugeicons:instagram" width="18" height="18">&nbsp;</iconify-icon>Instagram&nbsp;
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Linkedin" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:linkedin-01" iconname="hugeicons:linkedin-01" width="18" height="18">&nbsp;</iconify-icon>Linkedin&nbsp;
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(46, 100%, 29%);" id="certificate-title">Earn Your Credential</span></h2>
            <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(46, 100%, 29%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description">Includes access to premium content, community discussions, and expert feedback.</p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">3 weeks</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval">4-10 hours per week</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">Free</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="image" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(46, 100%, 29%);" id="audience-title">Who Is This For?</span></h2>
            <p style="text-align:center;" id="audience-description">This program is designed for individuals who want to:</p>
            <div class="column-header">
              <ul id="audience-items">
                <li>Develop valuable skills for personal or professional growth</li>
                <li>Apply knowledge through interactive activities</li>
              </ul>
            </div>
            <div class="column-header">
              <ul>
                <li>Improve efficiency and confidence in their abilities</li>
                <li>Take meaningful steps toward their goals</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url(https://cdn.minicoursegenerator.com/test/images/suleymanayki638633765662296072/80c72c1f-c8e0-4bad-9503-c7f67c6bdea9.png);background-position:'';background-size:'';" background-image="https://cdn.minicoursegenerator.com/test/images/suleymanayki638633765662296072/80c72c1f-c8e0-4bad-9503-c7f67c6bdea9.png" background-color="" background-type="image" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(46, 100%, 29%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><span style="color:hsl(0, 0%, 100%);"><strong>Gain practical knowledge and hands-on experience, including:</strong></span></p>
            <ul id="learning_outcomes-items" style="color:hsl(0, 0%, 100%);">
              <li><span style="color:hsl(0, 0%, 100%);">Essential concepts explained in a clear and engaging way</span></li>
              <li><span style="color:hsl(0, 0%, 100%);">Real-world applications to deepen understanding</span></li>
              <li><span style="color:hsl(0, 0%, 100%);">Step-by-step guidance to build confidence</span></li>
              <li><span style="color:hsl(0, 0%, 100%);">Interactive exercises to reinforce learning</span></li>
              <li><span style="color:hsl(0, 0%, 100%);">Access to exclusive resources and tools</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(46, 100%, 29%);" id="outro-title">Ready to Get Started?</span></h2>
            <p style="text-align:center;" id="outro-description">Explore the content, dive into new ideas, and expand your knowledge at your own pace.</p>
          </div>
        </div>
      </div>`,
        },
      },
    ],
  },
  {
    name: 'Horizon',
    id: 4,
    path: 'sections',
    primaryColor: '#273F2B',
    font: 'DM Sans',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/horizon.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/horizon.png',
        },
      },
      {
        type: 'Main',
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#f2f5eb;background-position:'';background-size:'';" background-image="" background-color="#f2f5eb" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(132, 25%, 20%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description"><span style="color:hsl(132, 25%, 20%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#f2f5eb;background-position:'';background-size:'';" background-image="" background-color="#f2f5eb" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">3 weeks</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval">4-10 hours per week</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">$10,00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h1 style="text-align:center;"><span style="color:hsl(132, 25%, 20%);" id="introduction-title">Discover, Learn, and Grow</span></h1>
            <p id="introduction-description"><span style="color:hsl(132, 25%, 20%);">Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
            </div>
          </div>
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(132, 25%, 20%);" id="author-title">Meet Your Instructor</span></h2>
            <p id="author-description"><span style="color:hsl(132, 25%, 20%);">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#273f2b;background-position:'';background-size:'';" background-image="" background-color="#273f2b" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(98, 24%, 78%);" id="audience-title">Who Is This For?</span></h2>
            <hr>
            <p style="text-align:center;" id="audience-description"><span style="color:hsl(98, 24%, 78%);">This program is designed for individuals who want to:</span></p>
            <div class="column-header">
              <ul id="audience-items" style="color:hsl(98, 24%, 78%);">
                <li><span style="color:hsl(98, 24%, 78%);">Develop valuable skills for personal or professional growth</span></li>
                <li><span style="color:hsl(98, 24%, 78%);">Apply knowledge through interactive activities</span></li>
              </ul>
            </div>
            <div class="column-header">
              <ul style="color:hsl(98, 24%, 78%);">
                <li><span style="color:hsl(98, 24%, 78%);">Improve efficiency and confidence in their abilities</span></li>
                <li><span style="color:hsl(98, 24%, 78%);">Take meaningful steps toward their goals</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      
      
      

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(132, 25%, 20%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <hr>
            <p id="learning_outcomes-description"><span style="color:hsl(132, 25%, 20%);"><strong>Gain practical knowledge and hands-on experience, including:</strong></span></p>
            <ul id="learning_outcomes-items">
              <li><span style="color:hsl(132, 25%, 20%);">Essential concepts explained in a clear and engaging way</span></li>
              <li><span style="color:hsl(132, 25%, 20%);">Real-world applications to deepen understanding</span></li>
              <li><span style="color:hsl(132, 25%, 20%);">Step-by-step guidance to build confidence</span></li>
              <li><span style="color:hsl(132, 25%, 20%);">Interactive exercises to reinforce learning</span></li>
              <li><span style="color:hsl(132, 25%, 20%);">Access to exclusive resources and tools</span></li>
            </ul>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#f2f5eb;background-position:'';background-size:'';" background-image="" background-color="#f2f5eb" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(132, 25%, 20%);" id="outro-title">Ready to Get Started?</span></h2>
            <p style="text-align:center;" id="outro-description"><span style="color:hsl(132, 25%, 20%);">Explore the content, dive into new ideas, and expand your knowledge at your own pace.</span></p>
          </div>
        </div>
      </div>`,
        },
      },
    ],
  },
  {
    name: 'Vibrant',
    id: 5,
    path: 'sections',
    font: 'Manrope',
    primaryColor: '#000000',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/vibrant.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/vibrant.jpg',
        },
      },
      {
        type: 'Main',
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#dffd6e;background-position:'';background-size:'';" background-image="" background-color="#dffd6e" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h1 style="text-align:center;"><span style="color:hsl(0, 0%, 0%);" id="introduction-title">Discover, Learn, and Grow</span></h1>
            <p style="text-align:center;" id="introduction-description"><span>Welcome to your learning journey! This is your opportunity to gain valuable new skills, expand your knowledge, and explore fresh perspectives that can transform the way you think and grow. Through engaging, interactive content, you'll immerse yourself in a dynamic learning experience designed to be both meaningful and enjoyable.&nbsp;</span></p>
            <p style="text-align:center;"><span>Whether you're looking to deepen your expertise, develop practical abilities, or simply broaden your horizons, this journey will empower you with the insights and tools you need to succeed. Get ready to learn, explore, and evolve!</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet-2.jpg">
            </div>
          </div>
          <div class="column" flex-size="undefined">
            <h2 id="author-title"><span>Meet Your Instructor</span></h2>
            <p id="author-description"><span>Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience. </span></p>
            <p><span> Follow me on:</span></p>
            <div class="button-wrapper" data-alignment="left" data-sizing="fit" id="social-links">
              <a class="simple-button" style="border:1px solid #547ef9;color:#547ef9;" href="" text="Youtube" textcolor="#547ef9" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:youtube" iconname="hugeicons:youtube" width="18" height="18">&nbsp;</iconify-icon>Youtube
              </a>
              <a class="simple-button" style="border:1px solid #547ef9;color:#547ef9;" href="" text="Instagram" textcolor="#547ef9" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:instagram" iconname="hugeicons:instagram" width="18" height="18">&nbsp;</iconify-icon>Instagram
              </a>
              <a class="simple-button" style="border:1px solid #547ef9;color:#547ef9;" href="" text="Tiktok" textcolor="#547ef9" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:tiktok" iconname="hugeicons:tiktok" width="18" height="18">&nbsp;</iconify-icon>Tiktok
              </a>
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 0%);" id="certificate-title">Earn Your Credential</span></h2>
            <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#ffd9d9;background-position:'';background-size:'';" background-image="" background-color="#ffd9d9" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;" id="video-section-title"><span>Watch &amp; Learn</span></h2>
            <p style="text-align:center;" id="video-section-description"><span>Get a glimpse of what's inside! Watch this short video to explore key insights and understand how this program can benefit you.</span></p>
            <div class="video-wrapper">
              <video class="video-player" src="https://player.vimeo.com/progressive_redirect/playback/1038160884/rendition/720p/file.mp4?loc=external&amp;log_user=0&amp;signature=e3371f1c844e5717ebef8396e458b401366fbbb67b1778a783d56e38494ea377" aspectratio="16/9" controls="true" controlslist="nodownload">&nbsp;</video>
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 0%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description"><span style="color:hsl(0, 0%, 0%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">3 weeks</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval">4-10 hours per week</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">$99,00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      
      

      <div class="simple-box-wrapper" style="background-color:#dffd6e;background-position:'';background-size:'';" background-image="" background-color="#dffd6e" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 0%);" id="audience-title">Who Is This For?</span></h2>
            <p id="audience-description"><span style="color:hsl(0, 0%, 0%);">This program is designed for individuals who want to:</span></p>
            <div class="column-header">
              <ul id="audience-items">
                <li>Develop valuable skills for personal or professional growth</li>
                <li>Apply knowledge through interactive activities</li>
              </ul>
            </div>
            <div class="column-header">
              <ul>
                <li>Improve efficiency and confidence in their abilities</li>
                <li>Take meaningful steps toward their goals</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 0%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including:</strong></p>
            <ul id="learning_outcomes-items">
              <li>Essential concepts explained in a clear and engaging way</li>
              <li>Real-world applications to deepen understanding</li>
              <li>Step-by-step guidance to build confidence</li>
              <li>Interactive exercises to reinforce learning</li>
              <li>Access to exclusive resources and tools</li>
            </ul>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 0%);" id="outro-title">Ready to Get Started?</span></h2>
            <p style="text-align:center;" id="outro-description">Explore the content, dive into new ideas, and expand your knowledge at your own pace.</p>
          </div>
        </div>
      </div>`,
        },
      },
    ],
  },
  {
    name: 'Discover',
    id: 6,
    path: 'sections',
    font: 'Nunito Sans',
    primaryColor: '#0077B6',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/discover.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/discover.png',
        },
      },
      {
        type: 'Main',
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span>🌍 </span><span style="color:hsl(201, 100%, 36%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p style="text-align:center;" id="introduction-description"><span style="color:hsl(201, 100%, 36%);">Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</span></p>
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/world-map.png" alt="">
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#f2f9ff;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#f2f9ff" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span>✨</span><span style="color:hsl(201, 100%, 36%);" id="author-title"> Who Are We?</span></h2>
            <p style="text-align:center;" id="author-description">I'm a paragraph. Click to start writing that will inform, inspire, or encourage your community. We know you have so many things to share with the world. Happy editing!</p>
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/discover-2.png" alt="">
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#f2f9ff;background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="#f2f9ff" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="button-wrapper" data-alignment="center" data-sizing="fit" id="social-links">
              <a class="simple-button" style="border:1px solid #0077b6;color:#0077b6;" href="" text="X" textcolor="#0077b6" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:new-twitter" iconname="hugeicons:new-twitter" width="18" height="18">&nbsp;</iconify-icon>X
              </a>
              <a class="simple-button" style="border:1px solid #0077b6;color:#0077b6;" href="" text="Facebook" textcolor="#0077b6" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:facebook-01" iconname="hugeicons:facebook-01" width="18" height="18">&nbsp;</iconify-icon>Facebook
              </a>
              <a class="simple-button" style="border:1px solid #0077b6;color:#0077b6;" href="" text="Instagram" textcolor="#0077b6" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:instagram" iconname="hugeicons:instagram" width="18" height="18">&nbsp;</iconify-icon>Instagram
              </a>
              <a class="simple-button" style="border:1px solid #0077b6;color:#0077b6;" href="" text="Tiktok" textcolor="#0077b6" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:tiktok" iconname="hugeicons:tiktok" width="18" height="18">&nbsp;</iconify-icon>Tiktok
              </a>
              <a class="simple-button" style="border:1px solid #0077b6;color:#0077b6;" href="" text="Linkedin" textcolor="#0077b6" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:linkedin-01" iconname="hugeicons:linkedin-01" width="18" height="18">&nbsp;</iconify-icon>Linkedin
              </a>
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(201, 100%, 36%);" id="certificate-title">Earn Your Credential</span></h2>
            <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#f2f9ff;background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="#f2f9ff" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(201, 100%, 36%);" id="program_details-title">📖 Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description">Includes access to premium content, community discussions, and expert feedback.</p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#f2f9ff;background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="#f2f9ff" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Ages 18-35</span></p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:youtube" iconname="hugeicons:youtube" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">Video content</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval">12+ Destinations</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">$5.95</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span>👀</span><span style="color:hsl(201, 100%, 36%);" id="audience-title"> Who Is This For?</span></h2>
            <p id="audience-description"><span>This program is designed for individuals who want to:</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="audience-items">
              <div class="card-box" type="numberedCard">
                <div class="card-header">
                  <p>01</p>
                </div>
                <div class="card-content">
                  <p><span>Develop valuable skills for personal or professional growth</span></p>
                </div>
              </div>
              <div class="card-box" type="numberedCard">
                <div class="card-header">
                  <p>02</p>
                </div>
                <div class="card-content">
                  <p><span>Apply knowledge through interactive activities</span></p>
                </div>
              </div>
              <div class="card-box" type="numberedCard">
                <div class="card-header">
                  <p>03</p>
                </div>
                <div class="card-content">
                  <p><span>Improve efficiency and confidence in their abilities</span></p>
                </div>
              </div>
              <div class="card-box" type="numberedCard">
                <div class="card-header">
                  <p>04</p>
                </div>
                <div class="card-content">
                  <p><span>Take meaningful steps toward their goals</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(201, 100%, 36%);" id="learning_outcomes-title">🗺️ What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including:</strong></p>
            <ul id="learning_outcomes-items">
              <li>Essential concepts explained in a clear and engaging way</li>
              <li>Real-world applications to deepen understanding</li>
              <li>Step-by-step guidance to build confidence</li>
              <li>Interactive exercises to reinforce learning</li>
              <li>Access to exclusive resources and tools</li>
            </ul>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#f2f9ff;background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="#f2f9ff" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(201, 100%, 36%);" id="outro-title">🌎 Ready to Get Started?</span></h2>
            <p style="text-align:center;" id="outro-description">Explore the content, dive into new ideas, and expand your knowledge at your own pace.</p>
          </div>
        </div>
      </div>`,
        },
      },
    ],
  },
  {
    name: 'Grow',
    id: 7,
    path: 'sections',
    font: 'Sora',
    primaryColor: '#0077B6',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/grow.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/grow.png',
        },
      },
      {
        type: 'Main',
        content: {
          html: `<div class="simple-box-wrapper" style="background-image:url(https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/grow-discover.jpg);background-position:top-center;background-size:cover;" background-image="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/grow-discover.jpg" background-color="" background-type="" background-size="cover" size-type="SCALE_TO_FILL" use-image-overlay="" background-position="top-center" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color=""><div class="simple-box"><div class="column" flex-size="undefined"><h1 style="text-align:center;">&nbsp;</h1><h1 style="text-align:center;"><span style="color:hsl(0,0%,0%);"><span id="introduction-title">Discover, Learn, and Grow</span></span></h1><p style="text-align:center;" id="introduction-description"><span>Welcome to your learning journey!&nbsp;</span></p><p style="text-align:center;"><span>Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p><p style="text-align:center;">&nbsp;</p></div></div></div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
            </div>
          </div>
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(240, 22%, 15%);" id="author-title">Meet Your Instructor</span></h2>
            <p id="author-description"><span style="color:hsl(240, 22%, 15%);">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</span></p>
            <div class="button-wrapper" data-alignment="left" data-sizing="fit" id="social-links">
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="X" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:new-twitter" iconname="hugeicons:new-twitter" width="18" height="18">&nbsp;</iconify-icon>X
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Facebook" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:facebook-01" iconname="hugeicons:facebook-01" width="18" height="18">&nbsp;</iconify-icon>Facebook
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Instagram" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:instagram" iconname="hugeicons:instagram" width="18" height="18">&nbsp;</iconify-icon>Instagram
              </a>
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 0%);" id="certificate-title">Earn Your Credential</span></h2>
            <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#F5F7FA;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#ffd9d9" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;" id="video-section-title"><span>Watch &amp; Learn</span></h2>
            <p style="text-align:center;" id="video-section-description"><span>Get a glimpse of what's inside! Watch this short video to explore key insights and understand how this program can benefit you.</span></p>
            <div class="video-wrapper">
              <video class="video-player" src="https://player.vimeo.com/progressive_redirect/playback/1038160884/rendition/720p/file.mp4?loc=external&amp;log_user=0&amp;signature=e3371f1c844e5717ebef8396e458b401366fbbb67b1778a783d56e38494ea377" aspectratio="16/9" controls="true" controlslist="nodownload">&nbsp;</video>
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 0%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description"><span style="color:hsl(0, 0%, 0%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">3 weeks</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval">4-10 hours per week</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">$10,00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="simple-box-wrapper" style="background-color:#ffffff;background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="#dffd6e" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 0%);" id="audience-title">Who Is This For?</span></h2>
            <p id="audience-description"><span>This program is designed for individuals who want to:</span></p>
            <div class="card-wrapper" id="audience-items">
              <div class="card-box" type="numberedCard">
                <div class="card-header">
                  <p>01</p>
                </div>
                <div class="card-content">
                  <p><span>Develop valuable skills for personal or professional growth</span></p>
                </div>
              </div>
              <div class="card-box" type="numberedCard">
                <div class="card-header">
                  <p>02</p>
                </div>
                <div class="card-content">
                  <p><span>Apply knowledge through interactive activities</span></p>
                </div>
              </div>
              <div class="card-box" type="numberedCard">
                <div class="card-header">
                  <p>03</p>
                </div>
                <div class="card-content">
                  <p><span>Improve efficiency and confidence in their abilities</span></p>
                </div>
              </div>
              <div class="card-box" type="numberedCard">
                <div class="card-header">
                  <p>04</p>
                </div>
                <div class="card-content">
                  <p><span>Take meaningful steps toward their goals</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#F5F7FA;background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 0%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including:</strong></p>
            <ul id="learning_outcomes-items">
              <li>Essential concepts explained in a clear and engaging way</li>
              <li>Real-world applications to deepen understanding</li>
              <li>Step-by-step guidance to build confidence</li>
              <li>Interactive exercises to reinforce learning</li>
              <li>Access to exclusive resources and tools</li>
            </ul>
          </div>
        </div>
      </div>


      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 0%);" id="outro-title">Ready to Get Started?</span></h2>
            <p style="text-align:center;" id="outro-description">Explore the content, dive into new ideas, and expand your knowledge at your own pace.</p>
          </div>
        </div>
      </div>`,
        },
      },
    ],
  },
  {
    name: 'Podcast',
    id: 8,
    path: 'sections',
    font: 'Inter',
    primaryColor: '#FF6B00',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/podcast.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/podcast.jpg',
        },
      },
      {
        type: 'Main',
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#ffffff;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#ffffff" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(25, 100%, 50%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span style="color:hsl(222, 36%, 11%);">Welcome to your learning journey! Gain new skills, expand your knowledge, and explore fresh perspectives. Engage with interactive content designed to help you learn in a meaningful and enjoyable way.</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#ffffff;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#ffffff" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(25, 100%, 50%);" id="author-title">🎙 About Me – Meet Your Mentor</span></h2>
            <p id="author-description"><span style="color:hsl(222, 36%, 11%);">Hi, I'm a podcast producer and host of the award-winning show Voices Unfiltered. When I started podcasting five years ago, I was just like you—unsure of my niche, nervous about my voice, and overwhelmed by all the technical aspects.</span></p>
            <p><span style="color:hsl(222, 36%, 11%);">Fast forward to today, and my podcast has reached thousands of listeners, secured sponsorships, and built a thriving community. Through this collection, I want to help you find your voice, just like I did!</span></p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/podcast-about.png" alt="">
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#ffffff;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#ffffff" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="button-wrapper" data-alignment="center" data-sizing="fit" id="social-links">
              <a class="simple-button" style="border:1px solid #ff6b00;color:#ff6b00;" href="" text="X" textcolor="#ff6b00" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:new-twitter" iconname="hugeicons:new-twitter" width="18" height="18">&nbsp;</iconify-icon>X
              </a>
              <a class="simple-button" style="border:1px solid #ff6b00;color:#ff6b00;" href="" text="Facebook" textcolor="#ff6b00" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:facebook-01" iconname="hugeicons:facebook-01" width="18" height="18">&nbsp;</iconify-icon>Facebook
              </a>
              <a class="simple-button" style="border:1px solid #ff6b00;color:#ff6b00;" href="" text="Instagram" textcolor="#ff6b00" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:instagram" iconname="hugeicons:instagram" width="18" height="18">&nbsp;</iconify-icon>Instagram
              </a>
              <a class="simple-button" style="border:1px solid #ff6b00;color:#ff6b00;" href="" text="Tiktok" textcolor="#ff6b00" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:tiktok" iconname="hugeicons:tiktok" width="18" height="18">&nbsp;</iconify-icon>Tiktok
              </a>
              <a class="simple-button" style="border:1px solid #ff6b00;color:#ff6b00;" href="" text="Linkedin" textcolor="#ff6b00" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:linkedin-01" iconname="hugeicons:linkedin-01" width="18" height="18">&nbsp;</iconify-icon>Linkedin
              </a>
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#ffffff;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#ffffff" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h1 id="podcast-episode-title"><span style="color:hsl(25, 100%, 50%);">🎵 Featured Podcast Episode</span></h1>
            <p id="podcast-episode-description"><span style="color:hsl(222, 36%, 11%);">Check out a sample podcast episode that demonstrates the key techniques covered in this collection.</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#ffffff;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#ffffff" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="raw-html-embed" id="podcast-player">
          <div style="left: 0; width: 100%; height: 152px; position: relative;">
            <iframe src="https://open.spotify.com/embed/episode/0m2YzCO3Pq5i8dbGk5KJI6?utm_source=oembed" style="top: 0; left: 0; width: 100%; height: 100%; position: absolute; border: 0;" allowfullscreen="" allow="clipboard-write; encrypted-media; fullscreen; picture-in-picture;"></iframe>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#2a2e36;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#2a2e36" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(25, 100%, 50%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><span style="color:hsl(0, 0%, 100%);">I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</span></p>
            <div class="column-header">
              <ul id="learning_outcomes-items">
                <li><span style="color:hsl(0, 0%, 100%);">Understand what makes your podcast unique and how to find your niche. Learn how to communicate your message effectively and engage your audience.</span></li>
                <li><span style="color:hsl(0, 0%, 100%);">Learn how to plan and outline your podcast episodes for maximum impact. Discover different formats and storytelling techniques.</span></li>
                <li><span style="color:hsl(0, 0%, 100%);">Master the technical aspects of podcasting. From setting up your recording space to editing your audio like a pro.</span></li>
              </ul>
            </div>
            <div class="column-header">
              <ul>
                <li><span style="color:hsl(0, 0%, 100%);">Explore the must-have tools for quality podcast production. From microphones to editing software, get recommendations for every budget.</span></li>
                <li><span style="color:hsl(0, 0%, 100%);">Create a strong brand identity and promote your podcast effectively. Understand SEO, social media strategies, and audience growth techniques.</span></li>
                <li><span style="color:hsl(0, 0%, 100%);">Learn how to publish your podcast on major platforms and explore monetization strategies such as sponsorships, memberships, and more.</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#ffffff;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#ffffff" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(25, 100%, 50%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description"><span style="color:hsl(222, 36%, 11%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#ffffff;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#ffffff" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">3 weeks</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval">4-10 hours per week</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">$10,00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      

      <div class="simple-box-wrapper" style="background-color:#ffffff;background-image:none;background-position:center;background-size:cover;" background-image="" background-color="#ffffff" background-type="color" background-size="cover" size-type="cover" use-image-overlay="false" background-position="center" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(25, 100%, 50%);" id="outro-title">Get Started Today!</span></h2>
            <p style="text-align:center;" id="outro-description"><span>Explore the content, dive into new ideas, and expand your knowledge at your own pace.</span></p>
          </div>
        </div>
      </div>`,
        },
      },
    ],
  },
  {
    name: 'Divine',
    id: 9,
    path: 'sections',
    font: 'Lato',
    primaryColor: '#c3a169 ',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/divine.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'left',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/divine.png',
        },
      },
      {
        type: 'Main',
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(37, 43%, 59%);" id="introduction-title">Embrace Wisdom, Find Your Path</span></h2>
            <p id="introduction-description"><span>Growth begins with curiosity and a willingness to explore new perspectives. Whether you're seeking personal transformation, professional development, or a deeper understanding of the world around you, this collection is designed to guide you every step of the way.</span></p>
            <p><span>Through insightful lessons, practical strategies, and timeless wisdom, you'll gain the clarity and confidence to navigate your journey with purpose and fulfillment.</span></p>
          </div>
        </div>
      </div>

     <div class="simple-box-wrapper" style="background-image:url(https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/divine-knowledge.jpg);background-position:top center;background-size:cover;" background-image="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/divine-knowledge.jpg" background-color="" background-type="image" background-size="cover" size-type="SCALE_TO_FILL" use-image-overlay="" background-position="top center" linear-value="" opacity="" overlay-color="">
       <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2>&nbsp;</h2>
            <h2>&nbsp;</h2>
            <h2><span style="color:hsl(37, 43%, 59%);" id="knowledge-title">The Power of Knowledge</span></h2>
            <p id="knowledge-description"><span style="color:hsl(0, 0%, 100%);">Discover the timeless wisdom of ancient traditions and modern insights that lead to clarity and inner peace. This program helps you connect with profound teachings, cultivate mindfulness, and navigate life with wisdom and balance.</span></p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="button-wrapper" data-alignment="center" data-sizing="fit" id="social-links">
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="X" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:new-twitter" iconname="hugeicons:new-twitter" width="18" height="18">&nbsp;</iconify-icon>X&nbsp;
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Facebook" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:facebook-01" iconname="hugeicons:facebook-01" width="18" height="18">&nbsp;</iconify-icon>Facebook&nbsp;
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Instagram" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:instagram" iconname="hugeicons:instagram" width="18" height="18">&nbsp;</iconify-icon>Instagram&nbsp;
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Tiktok" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:tiktok" iconname="hugeicons:tiktok" width="18" height="18">&nbsp;</iconify-icon>Tiktok&nbsp;
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Linkedin" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:linkedin-01" iconname="hugeicons:linkedin-01" width="18" height="18">&nbsp;</iconify-icon>Linkedin&nbsp;
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(37, 43%, 59%);" id="certificate-title">Earn Your Sacred Recognition</span></h2>
            <p id="certificate-description"><span>Successfully complete this course and earn a badge honoring your dedication to learning and self-discovery.&nbsp;</span></p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

     <div class="simple-box-wrapper" style="background-image:url(https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/divine-quite.png);background-position:center;background-size:cover;" background-image="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/divine-quite.png" background-color="" background-type="image" background-size="cover" size-type="SCALE_TO_FILL" use-image-overlay="" background-position="center" linear-value="" opacity="" overlay-color="">
       <div class="simple-box">
          <blockquote id="wisdom-quote">
            <p><span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="color:hsl(0, 0%, 100%);">&nbsp;"The path to understanding begins with curiosity. Let your heart and mind explore beyond the ordinary."</span></p>
            <p><span style="color:hsl(0, 0%, 100%);">Learn from enlightened guides who share knowledge rooted in experience and deeper awareness.</span></p>
          </blockquote>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(37, 43%, 59%);" id="audience-title">Who Is This For?</span></h2>
            <p id="audience-description"><span>This program is for those who wish to:</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="audience-items">
              <div class="card-box" type="numberedCard">
                <div class="card-header">
                  <p>01</p>
                </div>
                <div class="card-content">
                  <p><span>Deepen their understanding of life's mysteries</span></p>
                </div>
              </div>
              <div class="card-box" type="numberedCard">
                <div class="card-header">
                  <p>02</p>
                </div>
                <div class="card-content">
                  <p><span>Cultivate mindfulness and inner harmony</span></p>
                </div>
              </div>
              <div class="card-box" type="numberedCard">
                <div class="card-header">
                  <p>03</p>
                </div>
                <div class="card-content">
                  <p><span>Improve efficiency and confidence in their abilities</span></p>
                </div>
              </div>
              <div class="card-box" type="numberedCard">
                <div class="card-header">
                  <p>04</p>
                </div>
                <div class="card-content">
                  <p><span>Take meaningful steps toward their goals</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 id="learning_outcomes-title"><span>What You'll Discover</span></h2>
            <p id="learning_outcomes-description"><span>Journey through knowledge that enlightens and inspires, including:</span></p>
            <ul id="learning_outcomes-items">
              <li><span>Profound teachings from various traditions</span></li>
              <li><span>Meditative and reflective practices</span></li>
              <li><span>Insights into self-awareness and personal growth</span></li>
              <li><span>Stories and wisdom passed through generations</span></li>
              <li><span>Practical tools for mindful living</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url(http://cdn.minicoursegenerator.com/assets/landing-page-templates/content/divine-sky.jpg);background-position:center;background-size:'';" background-image="http://cdn.minicoursegenerator.com/assets/landing-page-templates/content/divine-sky.jpg" background-color="" background-type="image" background-size="" size-type="" use-image-overlay="" background-position="center" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 24%);" id="outro-title">Begin Your Journey</span></h2>
            <p id="outro-description"><span style="color:hsl(0, 0%, 24%);">Step forward with intention. Embrace the wisdom that calls to you and unlock the doors to deeper understanding.</span></p>
          </div>
        </div>
      </div>`,
        },
      },
    ],
  },
  {
    name: 'Playful',
    id: 10,
    path: 'sections',
    font: 'Barlow',
    primaryColor: '#708800',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/playful.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/playful.png',
        },
      },
      {
        type: 'Main',
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 17%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
              <p style="text-align:center;" id="introduction-description"><span style="color:hsl(0, 0%, 17%);">Welcome to your learning journey! This is your opportunity to gain valuable new skills, expand your knowledge, and explore fresh perspectives that can transform the way you think and grow. Through engaging, interactive content, you'll immerse yourself in a dynamic learning experience designed to be both meaningful and enjoyable.</span></p>
              <p style="text-align:center;"><span style="color:hsl(0, 0%, 17%);">Whether you're looking to deepen your expertise, develop practical abilities, or simply broaden your horizons, this journey will empower you with the insights and tools you need to succeed. Get ready to learn, explore, and evolve!</span></p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:#d9e59e;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#d9e59e" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 17%);" id="program_details-title">Program Details</span></h2>
              <p style="text-align:center;" id="program_details-description"><span style="color:hsl(0, 0%, 17%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:#d9e59e;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#d9e59e" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="card-wrapper" id="program_details-cards">
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="level">Beginner level</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="duration">3 weeks</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="recommended_interval">4-10 hours per week</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="price">$10,00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;" id="author-title"><span>Meet Your Instructor</span></h2>
              <p style="text-align:center;" id="author-description"><span>Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</span></p>
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/playful-img.png" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="button-wrapper" data-alignment="center" data-sizing="fit" id="social-links">
                <a class="simple-button" style="border:1px solid #2c2c2c;color:#2c2c2c;" href="" text="X" textcolor="#2c2c2c" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:new-twitter" iconname="hugeicons:new-twitter" width="18" height="18">&nbsp;</iconify-icon>X
                </a>
                <a class="simple-button" style="border:1px solid #2c2c2c;color:#2c2c2c;" href="" text="Facebook" textcolor="#2c2c2c" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:facebook-01" iconname="hugeicons:facebook-01" width="18" height="18">&nbsp;</iconify-icon>Facebook
                </a>
                <a class="simple-button" style="border:1px solid #2c2c2c;color:#2c2c2c;" href="" text="Instagram" textcolor="#2c2c2c" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:instagram" iconname="hugeicons:instagram" width="18" height="18">&nbsp;</iconify-icon>Instagram
                </a>
                <a class="simple-button" style="border:1px solid #2c2c2c;color:#2c2c2c;" href="" text="Tiktok" textcolor="#2c2c2c" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:tiktok" iconname="hugeicons:tiktok" width="18" height="18">&nbsp;</iconify-icon>Tiktok
                </a>
                <a class="simple-button" style="border:1px solid #2c2c2c;color:#2c2c2c;" href="" text="Linkedin" textcolor="#2c2c2c" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:linkedin-01" iconname="hugeicons:linkedin-01" width="18" height="18">&nbsp;</iconify-icon>Linkedin
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(0, 0%, 17%);" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description"><span>Complete all courses in this collection and receive a certificate recognizing your dedication and achievement.&nbsp;</span><br><br><span style="color:hsl(0, 0%, 17%);">Share your accomplishment and take the next step in your journey.</span></p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:#ffc55c;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#ffc55c" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 17%);" id="audience-title">Who Is This For?</span></h2>
              <p id="audience-description"><span style="color:hsl(0, 0%, 17%);">This program is designed for individuals who want to:</span></p>
              <div class="column-header">
                <ul id="audience-items">
                  <li><span style="color:hsl(0, 0%, 17%);">Develop valuable skills for personal or professional growth</span></li>
                  <li><span style="color:hsl(0, 0%, 17%);">Apply knowledge through interactive activities</span></li>
                </ul>
              </div>
              <div class="column-header">
                <ul>
                  <li><span style="color:hsl(0, 0%, 17%);">Improve efficiency and confidence in their abilities</span></li>
                  <li><span style="color:hsl(0, 0%, 17%);">Take meaningful steps toward their goals</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;" id="potential-title"><span style="color:hsl(0, 0%, 17%);">Unlock Your Potential</span></h2>
              <p id="potential-description"><span>Explore a world of knowledge designed to help you grow, adapt, and succeed. Whether you're looking to build new skills or deepen your understanding, this program provides the tools and support you need.</span></p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(0, 0%, 17%);" id="learning_outcomes-title">What You'll Learn</span></h2>
              <p id="learning_outcomes-description"><span style="color:hsl(0, 0%, 17%);"><strong>Gain practical knowledge and hands-on experience, including:</strong></span></p>
              <ul id="learning_outcomes-items">
                <li><span style="color:hsl(0, 0%, 17%);">Essential concepts explained in a clear and engaging way</span></li>
                <li><span style="color:hsl(0, 0%, 17%);">Real-world applications to deepen understanding</span></li>
                <li><span style="color:hsl(0, 0%, 17%);">Step-by-step guidance to build confidence</span></li>
                <li><span style="color:hsl(0, 0%, 17%);">Interactive exercises to reinforce learning</span></li>
                <li><span style="color:hsl(0, 0%, 17%);">Access to exclusive resources and tools</span></li>
              </ul>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="img-wrapper" id="illustration">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/playful-table.png" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:#ffaac5;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#ffaac5" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 17%);" id="outro-title">Ready to Get Started?</span></h2>
              <p style="text-align:center;" id="outro-description"><span style="color:hsl(0, 0%, 17%);">Explore the content, dive into new ideas, and expand your knowledge at your own pace.</span></p>
            </div>
          </div>
        </div>`,
        },
      },
    ],
  },
  {
    name: 'Dynamic',
    id: 11,
    path: 'sections',
    primaryColor: '#116CFF',
    font: 'Saira',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/dynamic.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/dynamic.png',
        },
      },
      {
        type: 'Main',
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 17%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p style="text-align:center;" id="introduction-description"><span style="color:hsl(0, 0%, 17%);">Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
            <div class="video-wrapper" id="intro-video">
              <video class="video-player" src="https://player.vimeo.com/progressive_redirect/playback/1038160884/rendition/720p/file.mp4?loc=external&amp;log_user=0&amp;signature=e3371f1c844e5717ebef8396e458b401366fbbb67b1778a783d56e38494ea377" aspectratio="16/9" controls="true" controlslist="nodownload">&nbsp;</video>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
            </div>
          </div>
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 17%);" id="author-title">Meet Your Instructor</span></h2>
            <p id="author-description"><span style="color:hsl(0, 0%, 17%);">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#116cff;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#116cff" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="button-wrapper" data-alignment="center" data-sizing="fit" id="social-links">
              <a class="simple-button" style="border:1px solid #002e47;color:#002e47;" href="" text="X" textcolor="#002e47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:new-twitter" iconname="hugeicons:new-twitter" width="18" height="18">&nbsp;</iconify-icon>X
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Facebook" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:facebook-01" iconname="hugeicons:facebook-01" width="18" height="18">&nbsp;</iconify-icon>Facebook&nbsp;
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Instagram" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:instagram" iconname="hugeicons:instagram" width="18" height="18">&nbsp;</iconify-icon>Instagram&nbsp;
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Tiktok" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:tiktok" iconname="hugeicons:tiktok" width="18" height="18">&nbsp;</iconify-icon>Tiktok&nbsp;
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Linkedin" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:linkedin-01" iconname="hugeicons:linkedin-01" width="18" height="18">&nbsp;</iconify-icon>Linkedin&nbsp;
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 17%);" id="certificate-title">Earn Your Credential</span></h2>
            <p id="certificate-description"><span style="color:hsl(0, 0%, 17%);">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;</span><br><br><span style="color:hsl(0, 0%, 17%);">Share your accomplishment and take the next step in your journey.</span></p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 17%);" id="audience-title">Who Is This For?</span></h2>
            <p id="audience-description"><span style="color:hsl(0, 0%, 17%);">This program is designed for individuals who want to:</span></p>
            <div class="column-header">
              <ul id="audience-items">
                <li><span style="color:hsl(0, 0%, 17%);">Develop valuable skills for personal or professional growth</span></li>
                <li><span style="color:hsl(0, 0%, 17%);">Apply knowledge through interactive activities</span></li>
              </ul>
            </div>
            <div class="column-header">
              <ul>
                <li><span style="color:hsl(0, 0%, 17%);">Improve efficiency and confidence in their abilities</span></li>
                <li><span style="color:hsl(0, 0%, 17%);">Take meaningful steps toward their goals</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#116cff;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#116cff" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 100%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description"><span style="color:hsl(0, 0%, 100%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#116cff;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#116cff" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">$200/Month</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval">6 Meet/Session</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price"Video &amp; Quiz</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 17%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><span style="color:hsl(0, 0%, 17%);"><strong>Gain practical knowledge and hands-on experience, including:</strong></span></p>
            <ul id="learning_outcomes-items">
              <li><span style="color:hsl(0, 0%, 17%);">Essential concepts explained in a clear and engaging way</span></li>
              <li><span style="color:hsl(0, 0%, 17%);">Real-world applications to deepen understanding</span></li>
              <li><span style="color:hsl(0, 0%, 17%);">Step-by-step guidance to build confidence</span></li>
              <li><span style="color:hsl(0, 0%, 17%);">Interactive exercises to reinforce learning</span></li>
              <li><span style="color:hsl(0, 0%, 17%);">Access to exclusive resources and tools</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 17%);" id="outro-title">Ready to Get Started?</span></h2>
            <p style="text-align:center;" id="outro-description"><span style="color:hsl(0, 0%, 17%);">Explore the content, dive into new ideas, and expand your knowledge at your own pace.</span></p>
          </div>
        </div>
      </div>`,
        },
      },
    ],
  },
  {
    name: 'Ascent',
    id: 12,
    path: 'sections',
    font: 'Inter',
    primaryColor: '#131313',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/ascent.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'center',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/ascent.png',
        },
      },
      {
        type: 'Main',
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#222424;background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="#292a2b" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(50, 100%, 50%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span style="color:hsl(0, 0%, 100%);">Welcome to your learning journey! Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
          </div>
        </div>
      </div>

     <div class="simple-box-wrapper" style="background-image:url(https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/ascent-image.png);background-position:center;background-size:cover;" background-image="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/ascent-discovery.png" background-color="" background-type="" background-size="cover" size-type="SCALE_TO_FILL" use-image-overlay="" background-position="center" linear-value="" opacity="" overlay-color="">
         <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="img-wrapper" id="feature-image">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/ascent-play.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
            </div>
          </div>
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 7%);" id="author-title">Meet Your Instructor</span></h2>
            <p id="author-description"><span style="color:hsl(0, 0%, 7%);">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="button-wrapper" data-alignment="center" data-sizing="fit" id="social-links">
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="X" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:new-twitter" iconname="hugeicons:new-twitter" width="18" height="18">&nbsp;</iconify-icon>X&nbsp;
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Facebook" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:facebook-01" iconname="hugeicons:facebook-01" width="18" height="18">&nbsp;</iconify-icon>Facebook&nbsp;
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Instagram" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:instagram" iconname="hugeicons:instagram" width="18" height="18">&nbsp;</iconify-icon>Instagram&nbsp;
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Tiktok" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:tiktok" iconname="hugeicons:tiktok" width="18" height="18">&nbsp;</iconify-icon>Tiktok&nbsp;
              </a>
              <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Linkedin" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:linkedin-01" iconname="hugeicons:linkedin-01" width="18" height="18">&nbsp;</iconify-icon>Linkedin&nbsp;
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 7%);" id="certificate-title">Earn Your Credential</span></h2>
            <p id="certificate-description"><span style="color:hsl(0, 0%, 7%);">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;</span><br><br><span style="color:hsl(0, 0%, 7%);">Share your accomplishment and take the next step in your journey.</span></p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 7%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description"><span style="color:hsl(0, 0%, 7%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">3 weeks</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval">4-10 hours per week</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">$10,00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#FFD400;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 7%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><span style="color:hsl(0, 0%, 7%);">Gain practical knowledge and hands-on experience, including:</span></p>
          </div>
          <div class="column" flex-size="undefined">
            <ul id="learning_outcomes-items">
              <li><span style="color:hsl(0, 0%, 7%);">Essential concepts explained in a clear and engaging way</span></li>
              <li><span style="color:hsl(0, 0%, 7%);">Real-world applications to deepen understanding</span></li>
              <li><span style="color:hsl(0, 0%, 7%);">Step-by-step guidance to build confidence</span></li>
              <li><span style="color:hsl(0, 0%, 7%);">Interactive exercises to reinforce learning</span></li>
              <li><span style="color:hsl(0, 0%, 7%);">Access to exclusive resources and tools</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="img-wrapper" id="audience-image">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/ascent-img.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 7%);" id="audience-title">Who Is This For?</span></h2>
            <p id="audience-description"><span style="color:hsl(0, 0%, 7%);">This program is designed for individuals who want to:</span></p>
            <div class="column-header">
              <ul id="audience-items">
                <li><span style="color:hsl(0, 0%, 7%);">Develop valuable skills for personal or professional growth</span></li>
                <li><span style="color:hsl(0, 0%, 7%);">Apply knowledge through interactive activities</span></li>
              </ul>
            </div>
            <div class="column-header">
              <ul>
                <li><span style="color:hsl(0, 0%, 7%);">Improve efficiency and confidence in their abilities</span></li>
                <li><span style="color:hsl(0, 0%, 7%);">Take meaningful steps toward their goals</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#292a2b;background-image:linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), url();background-position:'';background-size:'';" background-image="" background-color="#292a2b" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="rgba(255, 255, 255, 0)" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(0, 0%, 100%);" id="outro-title">Unlock Your Potential</span></h2>
            <p id="outro-description"><span style="color:hsl(0, 0%, 100%);">Explore a world of knowledge designed to help you grow, adapt, and succeed. Whether you're looking to build new skills or deepen your understanding, this program provides the tools and support you need.</span></p>
          </div>
        </div>
      </div>`,
        },
      },
    ],
  },
  {
    name: 'Organic',
    id: 13,
    path: 'sections',
    font: 'Georama',
    primaryColor: '#696D2C',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/organic.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'left',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/organic.png',
        },
      },
      {
        type: 'Main',
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#fff8ed;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#fff8ed" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(64, 42%, 30%);" id="introduction-title">Discover, Learn, and Grow</span></h2>
            <p id="introduction-description"><span style="color:hsl(64, 42%, 30%);"><strong>Welcome to your learning journey!</strong> Gain valuable skills, expand your knowledge, and explore new perspectives through engaging, interactive content. Whether you want to deepen your expertise, develop practical abilities, or broaden your horizons, this experience will empower you with the insights and tools to succeed. Get ready to learn, grow, and evolve!</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#fff8ed;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#fff8ed" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(64, 42%, 30%);" id="author-title">Meet Your Instructor</span></h2>
            <p id="author-description"><span style="color:hsl(64, 42%, 30%);">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</span></p>
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/discover-2.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#fff8ed;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#fff8ed" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="button-wrapper" data-alignment="left" data-sizing="fit" id="social-links">
              <a class="simple-button" style="border:1px solid #606060;color:#606060;" href="" text="X" textcolor="#606060" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:new-twitter" iconname="hugeicons:new-twitter" width="18" height="18">&nbsp;</iconify-icon>X
              </a>
              <a class="simple-button" style="border:1px solid #606060;color:#606060;" href="" text="Facebook" textcolor="#606060" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:facebook-01" iconname="hugeicons:facebook-01" width="18" height="18">&nbsp;</iconify-icon>Facebook
              </a>
              <a class="simple-button" style="border:1px solid #606060;color:#606060;" href="" text="Instagram" textcolor="#606060" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:instagram" iconname="hugeicons:instagram" width="18" height="18">&nbsp;</iconify-icon>Instagram
              </a>
              <a class="simple-button" style="border:1px solid #606060;color:#606060;" href="" text="Tiktok" textcolor="#606060" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:tiktok" iconname="hugeicons:tiktok" width="18" height="18">&nbsp;</iconify-icon>Tiktok
              </a>
              <a class="simple-button" style="border:1px solid #606060;color:#606060;" href="" text="Linkedin" textcolor="#606060" type="link" pdfname="" target="_blank" targetvalue="_blank">
                <iconify-icon class="simple-icon" icon="hugeicons:linkedin-01" iconname="hugeicons:linkedin-01" width="18" height="18">&nbsp;</iconify-icon>Linkedin
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(64, 42%, 30%);" id="certificate-title">Earn Your Credential</span></h2>
            <p id="certificate-description"><span style="color:hsl(64, 42%, 30%);">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;</span><br><br><span style="color:hsl(64, 42%, 30%);">Share your accomplishment and take the next step in your journey.</span></p>
          </div>
          <div class="column" flex-size="undefined">
            <div class="img-wrapper">
              <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(64, 42%, 30%);" id="audience-title">Who Is This For?</span></h2>
            <p id="audience-description"><span style="color:hsl(64, 42%, 30%);">This program is designed for individuals who want to:</span></p>
            <div class="column-header">
              <ul id="audience-items">
                <li><span style="color:hsl(64, 42%, 30%);">Develop valuable skills for personal or professional growth</span></li>
                <li><span style="color:hsl(64, 42%, 30%);">Apply knowledge through interactive activities</span></li>
              </ul>
            </div>
            <div class="column-header">
              <ul>
                <li><span style="color:hsl(64, 42%, 30%);">Improve efficiency and confidence in their abilities</span></li>
                <li><span style="color:hsl(64, 42%, 30%);">Take meaningful steps toward their goals</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="simple-box-wrapper" style="background-color:#979c7e;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#979c7e" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(0, 0%, 100%);" id="program_details-title">Program Details</span></h2>
            <p style="text-align:center;" id="program_details-description"><span style="color:hsl(0, 0%, 100%);">Includes access to premium content, community discussions, and expert feedback.</span></p>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#979c7e;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#979c7e" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <div class="card-wrapper" id="program_details-cards">
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="level">Beginner level</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="duration">3 weeks</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="recommended_interval">4-10 hours per week</p>
                </div>
              </div>
              <div class="card-box" type="highlightCard">
                <div class="card-header">
                  <button class="card-icon-button">
                    <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                  </button>
                </div>
                <div class="card-content">
                  <p id="price">$10,00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2><span style="color:hsl(64, 42%, 30%);" id="learning_outcomes-title">What You'll Learn</span></h2>
            <p id="learning_outcomes-description"><span style="color:hsl(64, 42%, 30%);"><strong>Gain practical knowledge and hands-on experience, including:</strong></span></p>
            <ul id="learning_outcomes-items">
              <li><span style="color:hsl(64, 42%, 30%);">Essential concepts explained in a clear and engaging way</span></li>
              <li><span style="color:hsl(64, 42%, 30%);">Real-world applications to deepen understanding</span></li>
              <li><span style="color:hsl(64, 42%, 30%);">Step-by-step guidance to build confidence</span></li>
              <li><span style="color:hsl(64, 42%, 30%);">Interactive exercises to reinforce learning</span></li>
              <li><span style="color:hsl(64, 42%, 30%);">Access to exclusive resources and tools</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="simple-box-wrapper" style="background-color:#fff8ed;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#fff8ed" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
        <div class="simple-box">
          <div class="column" flex-size="undefined">
            <h2 style="text-align:center;"><span style="color:hsl(64, 42%, 30%);" id="outro-title">Ready to Get Started?</span></h2>
            <p style="text-align:center;" id="outro-description"><span style="color:hsl(64, 42%, 30%);">Explore the content, dive into new ideas, and expand your knowledge at your own pace.</span></p>
          </div>
        </div>
      </div>`,
        },
      },
    ],
  },
  {
    name: 'Momentum',
    id: 14,
    path: 'sections',
    font: 'Space Grotesk',
    primaryColor: '#0453F1',
    thumbnail:
      'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/momentum.png',
    value: [
      {
        type: 'Header',
        content: {
          alignment: 'left',
          image:
            'https://cdn.minicoursegenerator.com/assets/landing-page-templates/header/momentum.png',
        },
      },
      {
        type: 'Main',
        content: {
          html: `<div class="simple-box-wrapper" style="background-color:#0453f1;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#0453f1" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(37, 100%, 96%);" id="introduction-title">Join the Experience, Make It Unforgettable! 🚀</span></h2>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(220, 97%, 48%);" id="intro-subtitle">Dive in, Explore more</span></h2>
              <p id="introduction-description"><span><strong>Welcome to your learning journey!</strong> This is your opportunity to gain valuable new skills, expand your knowledge, and explore fresh perspectives that can transform the way you think and grow.&nbsp;</span></p>
              <p><span>Through engaging, interactive content, you'll immerse yourself in a dynamic learning experience designed to be both meaningful and enjoyable. Whether you're looking to deepen your expertise, develop practical abilities, or simply broaden your horizons, this journey will empower you with the insights and tools you need to succeed. Get ready to learn, explore, and evolve!</span></p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/meet.png" alt="">
              </div>
            </div>
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(220, 97%, 48%);" id="author-title">Meet Your Instructor</span></h2>
              <p id="author-description">Gain insights from an industry expert with years of experience. Learn directly from professionals who bring real-world expertise to your learning experience.</p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="button-wrapper" data-alignment="left" data-sizing="fit" id="social-links">
                <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="X" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:new-twitter" iconname="hugeicons:new-twitter" width="18" height="18">&nbsp;</iconify-icon>X&nbsp;
                </a>
                <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Facebook" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:facebook-01" iconname="hugeicons:facebook-01" width="18" height="18">&nbsp;</iconify-icon>Facebook&nbsp;
                </a>
                <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Instagram" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:instagram" iconname="hugeicons:instagram" width="18" height="18">&nbsp;</iconify-icon>Instagram&nbsp;
                </a>
                <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Tiktok" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:tiktok" iconname="hugeicons:tiktok" width="18" height="18">&nbsp;</iconify-icon>Tiktok&nbsp;
                </a>
                <a class="simple-button" style="border:1px solid #002E47;color:#002E47;" href="" text="Linkedin" textcolor="#002E47" type="link" pdfname="" target="_blank" targetvalue="_blank">
                  <iconify-icon class="simple-icon" icon="hugeicons:linkedin-01" iconname="hugeicons:linkedin-01" width="18" height="18">&nbsp;</iconify-icon>Linkedin&nbsp;
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:#f4f6f8;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#f4f6f8" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2 style="text-align:center;"><span style="color:hsl(220, 97%, 48%);" id="program_details-title">Program Details</span></h2>
              <p style="text-align:center;" id="program_details-description">Includes access to premium content, community discussions, and expert feedback.</p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:#f4f6f8;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#f4f6f8" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="card-wrapper" id="program_details-cards">
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:analytics-03" iconname="hugeicons:analytics-03" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="level">Beginner level</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:clock-01" iconname="hugeicons:clock-01" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="duration">3 weeks</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:book-02" iconname="hugeicons:book-02" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="recommended_interval">4-10 hours per week</p>
                  </div>
                </div>
                <div class="card-box" type="highlightCard">
                  <div class="card-header">
                    <button class="card-icon-button">
                      <iconify-icon class="simple-icon" icon="hugeicons:dollar-circle" iconname="hugeicons:dollar-circle" width="24" height="24">&nbsp;</iconify-icon>
                    </button>
                  </div>
                  <div class="card-content">
                    <p id="price">$10,00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(220, 97%, 48%);" id="certificate-title">Earn Your Credential</span></h2>
              <p id="certificate-description">Successfully complete this course and earn a badge highlighting your skills and progress. &nbsp;<br><br>Share your accomplishment and take the next step in your journey.</p>
            </div>
            <div class="column" flex-size="undefined">
              <div class="img-wrapper">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/course-badge.png" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:#f4f6f8;background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="#f4f6f8" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%);" id="audience-title">Who Is This For?</span></h2>
              <p id="audience-description">This program is designed for individuals who want to:</p>
              <div class="column-header">
                <ul id="audience-items">
                  <li>Develop valuable skills for personal or professional growth</li>
                  <li>Apply knowledge through interactive activities</li>
                </ul>
              </div>
              <div class="column-header">
                <ul>
                  <li>Improve efficiency and confidence in their abilities</li>
                  <li>Take meaningful steps toward their goals</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%);" id="learning_outcomes-title">What You'll Learn</span></h2>
              <p id="learning_outcomes-description"><strong>Gain practical knowledge and hands-on experience, including:</strong></p>
              <ul id="learning_outcomes-items">
                <li>Essential concepts explained in a clear and engaging way</li>
                <li>Real-world applications to deepen understanding</li>
                <li>Step-by-step guidance to build confidence</li>
                <li>Interactive exercises to reinforce learning</li>
                <li>Access to exclusive resources and tools</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <h2><span style="color:hsl(217,99%,49%);" id="outro-title">Ready to Get Started?</span></h2>
              <p id="outro-description">Explore the content, dive into new ideas, and expand your knowledge at your own pace.</p>
            </div>
          </div>
        </div>

        <div class="simple-box-wrapper" style="background-color:'';background-image:linear-gradient(, ), url();background-position:'';background-size:'';" background-image="" background-color="" background-type="" background-size="" size-type="" use-image-overlay="" background-position="" linear-value="" opacity="" overlay-color="">
          <div class="simple-box">
            <div class="column" flex-size="undefined">
              <div class="img-wrapper" id="final-image">
                <img src="https://cdn.minicoursegenerator.com/assets/landing-page-templates/content/momentum-started.png" alt="">
              </div>
            </div>
          </div>
        </div>`,
        },
      },
    ],
  },
]
